import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import LinkIcon from '@mui/icons-material/Link';
import { useContext } from 'react';
import { appContext } from '../../../AppContext';
import { trimString } from '../../../utils/converter';
import LoadingDots from '../../Animations/LoadingDots';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const ListOfFiles = ({ history, getHistory, handleRemoveFile }) => {
  const { files, validatingFile, validateState, deletingFile } = useContext(appContext);

  const getValidatingFileIndex = () => {
    return files.findIndex((file) => file.file.name === validatingFile);
  };

  return (
    <>
      <div className="h-[200px] w-full overflow-y-auto flex flex-col items-center scroll-container gap-2 animate-fade-in-second">
        {files.map((fileObj, index) => (
          <div key={index} className="w-full">
            {/* SRC File */}
            <div
              className={`h-[46px] w-full flex items-center bg-core-black-contrast p-3 rounded-sm text-sm text-core-grey-60
                ${getValidatingFileIndex() === index && 'border border-slate-grey'}`}
              // ${!validateState && validationComplete ? 'bg-[rgba(15,96,0,0.1)]' : ''} // TODO Background for completed validation of file?
              key={`${index}-src`}
            >
              <p className="text-sm">{trimString(fileObj.file.name)}</p>

              {validateState || deletingFile ? (
                <>
                  {getValidatingFileIndex() === index && (
                    <div className="ml-auto w-[24px] h-full">
                      <LoadingDots spinningRadius={10} heightWidthPx="24px" />
                    </div>
                  )}
                </>
              ) : (
                <DeleteIcon
                  onClick={() => handleRemoveFile(index)}
                  className="ml-auto hover:text-minima-core-orange cursor-pointer"
                />
              )}
              {fileObj.validated && (
                <div className="ml-auto">
                  <CheckCircleIcon className="text-status-green" />
                </div>
              )}
            </div>

            {/* JSON File */}
            {fileObj.jsonFileName && (
              <>
                <div className="flex items-center justify-center ">
                  {/* Connecting lines(border) and link */}
                  <div className="relative w-[15px] h-[20px] bg-core-black-contrast z-0" />
                  <LinkIcon className="absolute z-10 text-core-grey-60 transform rotate-90" />
                </div>
                <div
                  className={`h-[46px] w-full flex items-center bg-core-black-contrast p-3 rounded-sm text-sm text-core-grey-60 
               
              ${getValidatingFileIndex() === index && 'border border-slate-grey'}`}
                  key={`${index}-json`}
                >
                  {/* JSON File */}
                  <p> {fileObj.jsonFileName}</p>
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </>
  );
};
